import { getAll, get } from '@bigyouth/base'

import { get as getPipe } from '../utils/sigpipe'

import { ACTIONS as MODAL_ACTIONS } from './modal'

/**
 * Can be placed on an element to open a modal when the element is triggered by mouse or keyboard.
 *
 * Props:
 * target(string, required): Query string for the targetted modal
 */
export default {
  name: 'modal-control',

  events: [
    {
      on: 'click',
      handle: 'openModal',
    },
  ],

  openModal () {
    if (!this.pipe) {
      try {
        const modal = get(this.props.target)

        this.pipe = getPipe(modal.getAttribute('data-pipe-id'))
      } catch (e) {
        console.error(
          `[MODAL-CONTROL] Are you sure target ${this.props.target} exists ?`,
        )
      }
    }

    if (this.props.sessionId) {
      getAll('[js-modal-session-id]').forEach(input => { input.value = this.props.sessionId })

      get('[js-signin-title]').innerHTML = 'Connectez vous pour gagner du temps lors de votre inscription'
      get('[js-signin-type]').value = 'training'
      get('[js-signin-create-account-training]').classList.remove('hidden')
      get('[js-signin-create-account-training]').setAttribute('aria-hidden', false)
      get('[js-signin-create-account]').classList.add('hidden')
      get('[js-signin-create-account]').setAttribute('aria-hidden', true)
    }

    if (this.props.register && get('[js-signin-title]').innerHTML !== 'Se connecter') {
      get('[js-signin-title]').innerHTML = 'Se connecter'
      get('[js-signin-type]').value = 'reg'
      get('[js-signin-create-account-training]').classList.add('hidden')
      get('[js-signin-create-account-training]').setAttribute('aria-hidden', true)
      get('[js-signin-create-account]').classList.remove('hidden')
      get('[js-signin-create-account]').setAttribute('aria-hidden', false)
    }

    if (this.props.registerInTunnel) {
      get('[js-signin-type]').value = 'trainingTunnel'
    }

    if (this.pipe) {
      this.pipe.write({ action: MODAL_ACTIONS.OPEN, emitterEl: this.el })
    }
  },
}
